import {useMutation, useQueryClient} from '@tanstack/react-query';
import {ContentSubmissionComment} from '@/types/contentSubmission';
import contentSubmissionUpdaters from '@/api/updaters/contentSubmission';
import {CONTENT_SUBMISSION_QUERY_KEY} from '@/hooks/queries/use-content-submission-query';

type CreateCommentParams = {
  content: string;
  email: string;
  fullName: string;
  step?: string;
  contentSubmissionVersion: {
    id: string;
    contentSubmissionComments: ContentSubmissionComment[];
  };
};

function useCreateCommentMutation({
  contentSubmissionId,
}: {
  contentSubmissionId: string;
}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['createComment', contentSubmissionId],
    mutationFn: (params: CreateCommentParams) =>
      contentSubmissionUpdaters.addComment(params),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CONTENT_SUBMISSION_QUERY_KEY, contentSubmissionId],
      });
    },
  });
}

export default useCreateCommentMutation;
